import { combineReducers } from 'redux';

import Actions from './integration-actions';
import Api from './integration-api';
import DataSourceApi from './data-source-api';
import Collection from './integration-collection';
import Model from './integration-model';
import integrations from './integration-reducer';
import integrationTemplates from './integration-template-reducer';
import sagas from './integration-sagas';
import Selectors from './integration-selectors';
import Enums from './integration-enums';
import * as Utils from './utils';

const reducer = combineReducers({
  integrations,
  integrationTemplates,
});

export default {
  Actions,
  Api:       { ...Api, ...DataSourceApi },
  Collection,
  Model,
  namespace: 'integration',
  reducer,
  sagas:     [sagas],
  Selectors,
  Enums,
  Utils,
};
